import fraisBddCommericalCactusProjectsTh from './fraisBddCommericalCactusProjectsTh';
export default class fraisBddCommericalCactusTh {
  constructor(data) {
    this.name = data.name;
    this.alteo = data.alteo;
    this.alteo1 = data.alteo1;
    this.alteo1_ht = data.alteo1_ht;

    this.alteo2 = data.alteo2;
    this.externe = data.externe;
    this.externe_ht = data.externe_ht;

    this.interne = data.interne;
    this.interne_ht = data.interne_ht;

    this.commercial = data.commercial;
    this.commercial_ht = data.commercial_ht;

    this.total = data.total;
    this.cactus = data.cactus;
    this.cactus_ht = data.cactus_ht;

    this.check = false;
    this.loadingDetailt = false;
    this.projects = data.projects;
  }

  update(data) {
    this.projects = data.projects.map(item =>
      fraisBddCommericalCactusProjectsTh.create(item)
    );
  }
  static create(data) {
    return new fraisBddCommericalCactusTh(data);
  }
}
